<template>
	<div class="form-autocomplete col-12 no-padding">
		<div v-if="!isMultiple">
			<div class="d-flex align-items-center">
				<input
					v-if="!value || !value.api_id"
					data-element="searchLocationInput"
					class="col-12 no-padding searchLocationInput p-0 border-none"
					:value="textSearch"
					type="text"
					:placeholder="placeholder"
					@input="textSearch=$event.target.value"
					@keyup="showOptions"
					@keydown.down="moveDown"
					@keydown.up="moveUp"
					@keydown.enter="select"
				>
			</div>

			<div class="">
				<div v-if="value && value.api_id" class="row justify-content-around">
					<div class="col-10 col-lg-11 col-xl-10 text-1-line no-padding align-middle wrapper-label">
						<slot name="selected" :item="value">
							{{ value.Name }}
						</slot>
					</div>
					<div
						class="col-2 col-lg-1 col-xl-2 hammer-wrapper-img"
						@click="clearItem"
					>
						<img
							src="/icons/close-thick.svg"
							alt="Close"
							height="24"
							width="24"
						>
					</div>
				</div>
			</div>
			<ul v-show="isShow" class="options autocomplete-options">
				<li
					v-for="(item, index) in test"
					:key="index"
					:class="{'highlighted': index === highlightedPosition}"
					@click="selectItem(item)"
				>
					<slot :item="item">
						{{ item.Name }} ({{ item.Label }})
					</slot>
				</li>
				<li v-if="test.length===0">
					Não Encontrado
				</li>
			</ul>
			<template v-if="value">
                <input
                    v-if="value.Label === 'Zona'"
                    id="local"
                    type="hidden"
                    name="zona"
                    :value="value.api_id"
                >
				<input
					v-if="value.Label === 'Freguesia'"
					id="local"
					type="hidden"
					name="parish"
					:value="value.api_id"
				>
				<input
					v-if="value.Label === 'Concelho'"
					id="local"
					type="hidden"
					name="county"
					:value="value.api_id"
				>
				<input
					v-if="value.Label === 'Distrito'"
					id="local"
					type="hidden"
					name="district"
					:value="value.api_id"
				>
                <input
                    v-if="value.Label === 'Ilha (RAM)'"
                    id="local"
                    type="hidden"
                    name="district"
                    :value="value.api_id"
                >
                <input
                    v-if="value.Label === 'Ilha (RAA)'"
                    id="local"
                    type="hidden"
                    name="district"
                    :value="value.api_id"
                >
			</template>
			<input
				v-if="!value || value === ''"
				id="local"
				type="hidden"
				name="district"
				value=""
			>
		</div>
	</div>
</template>

<script>
export default {
    name: "FormAutoComplete",
    props: {
        isMultiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Escolha uma Localização',
        },
        options: {
            type: Array,
            default() {
                return this.test;
            },
        },
        value: {
            type: Object,
            default() {
                return {
                    api_id: null,
                    Label: null,
                    Name: null,
                };
            },
        },

    },
    data() {
        return {
            textSearch: '',
            highlightedPosition: 0,
            isShow: false,
            test: [],
            concelhos: [],
            requestLocal: {
                Label: null,
                Name: null,
                api_id: null,
            },
        }
    },
    computed: {
        selectedItems() {
            if (this.isMultiple) {
                return this.value.map(v => v.uid);
            }
            return [];
        },

    },
    watch: {

        textSearch: function (newQuestion, oldQuestion) {
            //     this.$nextTick(() => {
            this.searchLocation()
            // })
        }

    },
    mounted() {
        console.debug('prop value', this.value)
        this.requestLocal = this.value
        this.$nextTick(() => {
            this.selectItem(this.requestLocal, 'mounted');
        })
    },
    methods: {
        searchLocation() {
            if (this.textSearch.length > 2) {
                // axios.get(route('locations_vue') + "?locais=" + this.textSearch + "&format=json")
                //     .then(response => {
                //         this.test = response.data
                //         sessionStorage.setItem(`seearch:${this.textSearch}`, JSON.stringify(this.test))
                //     })
                //run showOption hehere instead of v-on:keyup
                if (sessionStorage.getItem(`seearch:${this.textSearch}`)) {
                    this.test = JSON.parse(sessionStorage.getItem(`seearch:${this.textSearch}`));
                } else {
                    axios.get(route('locations_vue') + "?locais=" + this.textSearch + "&format=json")
                        .then(response => {
                            this.test = response.data
                            sessionStorage.setItem(`seearch:${this.textSearch}`, JSON.stringify(this.test))
                        })
                }

            }
        },
        moveDown() {
            if (!this.isShow) {
                return
            }
            console.log(this.highlightedPosition);
            this.highlightedPosition =
                (this.highlightedPosition + 1) % this.test.length
        },
        moveUp() {
            if (!this.isShow) {
                return
            }
            this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.test.length - 1 : this.highlightedPosition - 1
        },
        getConcelhos(distritoId, distritoLabel) {
            console.log(distritoLabel);
            this.districtlabel = distritoLabel;
            this.districtid = distritoId;
            axios
                .get(route('locations_vue') + "?locais=" + this.textSearch + "&format=json")
                .then(response => (this.concelhos = response.data))
        },
        inSelectedItems(api_id) {
            return this.selectedItems.includes(api_id);
        },
        showOptions() {


            if (this.textSearch.length > 2) {

                this.isShow = true;
            } else {
                this.isShow = false
            }
        },
        select() {
            const selectedOption = this.test[this.highlightedPosition]
            this.textSearch = '';
            this.isShow = false;
            // this.$emit('update:item', item);
            this.$emit('input', selectedOption);
            this.$emit('onSelectItem', selectedOption);
            setTimeout(function () {
                // document.getElementById('advancedSearchForm').submit();
                //Codigo de cima só submetia o form normalmente sem passar pela funçao de validação mencionada no onsubmit na tag form
                //com o codigo debaixo mesmo no auto submit do form no preenchimento dos selects o codigo nao passa por cima da validação

                // CUIDADO!!! AO MEXER AQUI EXISTE OUTRO TRIGGER AO FORMULARIO PARA OS OUTROS SELECTORES QUE NAO SÂO A LOCALIZAÇAÕ

                //console.log();
                document.getElementById('advancedSearchForm').dispatchEvent(new CustomEvent('submit', {cancelable: true}));
            }, 5);
        },
        selectItem(item, mounted = null) {
            //If location is an island, change label to district
            if (!item) {
                return;
            }

            if (item.Label !== 'Distrito'
                && item.Label !== 'Concelho'
                && item.Label !== 'Freguesia'
                && item.Label !== 'Zona'
                && item.Label !== 'Ilha (RAM)'
                && item.Label !== 'Ilha (RAA)') {
                item.Label = 'Zona';
            }

            console.debug('selectItem', item, mounted);

            this.textSearch = '';
            this.isShow = false;
            // this.$emit('update:item', item);
            if (item && item.hasOwnProperty('id')) {
                if (item.id != null && item.id != '' && item.id != 'somethingelse') {
                    $('#basicSearchForm').find('.searchLocationInput').css('border', '1px solid #ccc');
                }
            }

            this.$emit('input', item);
            this.$emit('onSelectItem', item);

            if (mounted === null) {
                setTimeout(function () {
                    // document.getElementById('advancedSearchForm').submit();
                    //Codigo de cima só submetia o form normalmente sem passar pela funçao de validação mencionada no onsubmit na tag form
                    //com o codigo debaixo mesmo no auto submit do form no preenchimento dos selects o codigo nao passa por cima da validação

                    // CUIDADO!!! AO MEXER AQUI EXISTE OUTRO TRIGGER AO FORMULARIO SÓ PARA O SELECTOR DA LOCALIZAÇÃO

                    document.getElementById('advancedSearchForm').dispatchEvent(new CustomEvent('submit', {cancelable: true}));
                }, 5);
            }
        },
        clearItem() {

            this.textSearch = '';
            // this.$emit('update:item', {
            //   id: undefined,
            //   title: undefined,
            // });
            console.log(this);
            this.$emit('input', {
                api_id: null,
                Label: null,
                Name: null,
            });
            this.$emit('onClearItem');
        },
        addItem(item) {
            if (!this.inSelectedItems(item.uid)) {
                this.textSearch = '';
                this.isShow = false;
                const items = JSON.parse(JSON.stringify(this.value));
                items.push(item);
                // this.$emit('update:item', items);
                this.$emit('input', items);
                this.$emit('onAddItem', items);
            }
        },
        removeItem(index) {
            this.textSearch = '';
            const items = JSON.parse(JSON.stringify(this.value));
            items.splice(index, 1);
            // this.$emit('update:item', items);
            this.$emit('input', items);
            this.$emit('onRemoveItem', items);
        },
    }
}
</script>

<style scoped lang="scss">
.searchLocationInput {
    background-color: #fff;
}

.hammer-wrapper-img {
    line-height: 23px;
}

@media screen and (max-width: 1024px) {
    .wrapper-label {
        margin-left: -6%;
    }

    .hammer-wrapper-img {
        margin-right: -4%;
    }
}

@media screen and (max-width: 991px) {
    .wrapper-label {
        margin-left: -20%;
    }

    .hammer-wrapper-img {
        margin-right: -20%;
    }
}

@media screen and (max-width: 540px) {
    .wrapper-label {
        margin-left: -3%;
    }

    .hammer-wrapper-img {
        margin-right: -3%;
    }
}
</style>
